import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './DashboardIcons';
import { canViewFinance } from '../../config/organization';

const BASE_ACTIONS = [
  { name: 'إضافة لاعب', href: '/players', icon: 'users' },
  { name: 'إضافة فريق', href: '/teams', icon: 'userGroup' },
  { name: 'إضافة مباراة', href: '/matches', icon: 'calendar' },
  { name: 'إضافة بطولة', href: '/tournaments', icon: 'trophy' },
];
const FINANCE_ACTION = { name: 'تسجيل مصروف', href: '/expenses', icon: 'banknotes' };
const SETTINGS_ACTION = { name: 'الإعدادات', href: '/settings', icon: 'cog' };

export const QuickActions = ({ user }) => {
  const actions = canViewFinance(user) ? [...BASE_ACTIONS, FINANCE_ACTION, SETTINGS_ACTION] : [...BASE_ACTIONS, SETTINGS_ACTION];

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="quick-actions">
      <h3 className="mb-3 text-sm font-bold text-slate-800">إجراءات سريعة</h3>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {actions.map((a) => (
          <Link
            key={a.name}
            to={a.href}
            data-testid={`quick-action-${a.href.replace('/', '')}`}
            className="group flex flex-col items-center gap-1.5 rounded-lg border border-slate-100 bg-slate-50/60 px-2 py-3 text-center transition-colors hover:border-teal-200 hover:bg-teal-50"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white border border-slate-200 text-[#16233b] transition-colors group-hover:text-teal-700">
              <Icon name={a.icon} className="w-4 h-4" />
            </span>
            <span className="text-xs font-semibold text-slate-700">{a.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
